"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeftContent = void 0;
var react_1 = __importStar(require("react"));
require("../../../index.css");
var LeftContent = /** @class */function (_super) {
  __extends(LeftContent, _super);
  function LeftContent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.renderContent = function () {
      var _a;
      var contentView;
      var contentListView = [];
      if (_this.props.contentList) {
        (_a = _this.props.contentList) === null || _a === void 0 ? void 0 : _a.map(function (data, index) {
          contentListView.push(react_1.default.createElement("p", {
            key: index,
            className: "text-base leading-7 text-justify"
          }, data));
          return null;
        });
        contentView = contentListView;
      }
      return contentView;
    };
    return _this;
  }
  LeftContent.prototype.render = function () {
    var defaultClassName = "relative lg:mx-auto lg:max-w-7xl lg:grid lg:grid-cols-2 lg:gap-24 lg:items-start";
    if (this.props.className) {
      defaultClassName += " ".concat(this.props.className);
    }
    return react_1.default.createElement("div", {
      className: defaultClassName
    }, react_1.default.createElement("div", {
      className: "relative mx-auto max-w-md sm:max-w-3xl"
    }, react_1.default.createElement("div", {
      className: "pt-8 sm:pt-16 lg:pt-20"
    }, react_1.default.createElement("h2", {
      className: "text-3xl text-gray-900 font-extrabold tracking-tight sm:text-4xl"
    }, this.props.title), react_1.default.createElement("div", {
      className: "mt-6 text-gray-500 space-y-6"
    }, this.renderContent(), this.props.callToAction))), react_1.default.createElement("div", {
      className: "relative mt-8 sm:mt-0 sm:py-16 lg:py-0"
    }, react_1.default.createElement("div", {
      className: "hidden sm:block"
    }, react_1.default.createElement("div", {
      className: "absolute inset-y-0 w-full bg-gray-50 rounded-l-3xl lg:left-16"
    }), react_1.default.createElement("svg", {
      className: "absolute top-8 right-1/2 -mr-3 lg:m-0 lg:left-0",
      width: "404",
      height: "392",
      fill: "none",
      viewBox: "0 0 404 392"
    }, react_1.default.createElement("defs", null, react_1.default.createElement("pattern", {
      id: "837c3e70-6c3a-44e6-8854-cc48c737b659",
      x: "0",
      y: "0",
      width: "20",
      height: "20",
      patternUnits: "userSpaceOnUse"
    }, react_1.default.createElement("rect", {
      x: "0",
      y: "0",
      width: "4",
      height: "4",
      className: "text-gray-200",
      fill: "currentColor"
    }))), react_1.default.createElement("rect", {
      width: "404",
      height: "392",
      fill: "url(#837c3e70-6c3a-44e6-8854-cc48c737b659)"
    }))), react_1.default.createElement("div", {
      className: "relative mx-auto max-w-md sm:max-w-3xl lg:max-w-none lg:py-20"
    }, react_1.default.createElement("div", {
      className: "relative pt-64 pb-10 rounded-2xl ".concat(this.props.imgContain ? "" : "shadow-xl", " overflow-hidden")
    }, react_1.default.createElement("img", {
      className: "absolute inset-0 h-full w-full ".concat(this.props.imgContain ? "object-contain" : "object-cover"),
      src: this.props.image,
      alt: ""
    }), react_1.default.createElement("div", {
      className: "relative px-8"
    }, react_1.default.createElement("blockquote", {
      className: "pt-20"
    }))))));
  };
  return LeftContent;
}(react_1.Component);
exports.LeftContent = LeftContent;